import { jsx as _jsx } from "react/jsx-runtime";
import { ReactEditor, useSlate } from "slate-react";
import { isMarkActive, toggleMark } from "../../../helpers";
import { StyleControlButton } from "../../Molecules";
var MarkButton = function (_a) {
    var control = _a.control, last = _a.last;
    var editor = useSlate();
    var isFocused = ReactEditor.isFocused(editor);
    return (_jsx(StyleControlButton, { active: isMarkActive(editor, control.style), onMouseDown: function (event) {
            event.preventDefault();
            toggleMark(editor, control.style);
        }, Icon: control.Icon, label: control.label, isFocused: isFocused, testId: control.testId, last: last }));
};
export default MarkButton;
